/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus = exports.WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus = exports.WixpressSubscriptionsApiV1ActionTypeEnumActionType = exports.SubscriptionType = exports.SubscriptionFrequency = exports.Status = exports.SortOrder = exports.ResumeAt = exports.PausePolicy = exports.PauseAt = exports.ItemCategory = exports.IdentityType = exports.HistoryActionInitiator = exports.ExtendPolicyType = exports.DurationUnit = exports.CollectionMethod = exports.CancellationInitiator = exports.BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus = exports.BillingSubscriptionsApiV1PaymentStatusEnumPaymentStatus = exports.BillingSubscriptionsApiV1ActionTypeEnumActionType = exports.ActionInitiator = void 0;
var ActionInitiator;
(function (ActionInitiator) {
    ActionInitiator["UNDEFINED"] = "UNDEFINED";
    ActionInitiator["BUSINESS"] = "BUSINESS";
    ActionInitiator["CUSTOMER"] = "CUSTOMER";
    ActionInitiator["SYSTEM"] = "SYSTEM";
})(ActionInitiator = exports.ActionInitiator || (exports.ActionInitiator = {}));
var BillingSubscriptionsApiV1ActionTypeEnumActionType;
(function (BillingSubscriptionsApiV1ActionTypeEnumActionType) {
    BillingSubscriptionsApiV1ActionTypeEnumActionType["NONE"] = "NONE";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["CREATION"] = "CREATION";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["CANCEL"] = "CANCEL";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["CYCLE_AUTO_RENEW_ON"] = "CYCLE_AUTO_RENEW_ON";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["CYCLE_AUTO_RENEW_OFF"] = "CYCLE_AUTO_RENEW_OFF";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["PAUSE"] = "PAUSE";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["RESUME"] = "RESUME";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["MARK_AS_PAID"] = "MARK_AS_PAID";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["EXTEND"] = "EXTEND";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["UPDATE"] = "UPDATE";
    BillingSubscriptionsApiV1ActionTypeEnumActionType["UPDATE_START_DATE"] = "UPDATE_START_DATE";
})(BillingSubscriptionsApiV1ActionTypeEnumActionType = exports.BillingSubscriptionsApiV1ActionTypeEnumActionType || (exports.BillingSubscriptionsApiV1ActionTypeEnumActionType = {}));
var BillingSubscriptionsApiV1PaymentStatusEnumPaymentStatus;
(function (BillingSubscriptionsApiV1PaymentStatusEnumPaymentStatus) {
    BillingSubscriptionsApiV1PaymentStatusEnumPaymentStatus["UNKNOWN"] = "UNKNOWN";
    BillingSubscriptionsApiV1PaymentStatusEnumPaymentStatus["UNPAID"] = "UNPAID";
    BillingSubscriptionsApiV1PaymentStatusEnumPaymentStatus["PAID"] = "PAID";
})(BillingSubscriptionsApiV1PaymentStatusEnumPaymentStatus = exports.BillingSubscriptionsApiV1PaymentStatusEnumPaymentStatus || (exports.BillingSubscriptionsApiV1PaymentStatusEnumPaymentStatus = {}));
var BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus;
(function (BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus) {
    BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["UNKNOWN"] = "UNKNOWN";
    BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["DRAFT"] = "DRAFT";
    BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["PENDING"] = "PENDING";
    BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["ACTIVE"] = "ACTIVE";
    BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["PAUSED"] = "PAUSED";
    BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["ENDED"] = "ENDED";
    BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["CANCELED"] = "CANCELED";
})(BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus = exports.BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus || (exports.BillingSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus = {}));
var CancellationInitiator;
(function (CancellationInitiator) {
    CancellationInitiator["UNDEFINED"] = "UNDEFINED";
    CancellationInitiator["OWNER"] = "OWNER";
    CancellationInitiator["MEMBER"] = "MEMBER";
    CancellationInitiator["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
    CancellationInitiator["SETUP_FAILURE"] = "SETUP_FAILURE";
})(CancellationInitiator = exports.CancellationInitiator || (exports.CancellationInitiator = {}));
var CollectionMethod;
(function (CollectionMethod) {
    CollectionMethod["UNKNOWN"] = "UNKNOWN";
    CollectionMethod["AUTO_CHARGE"] = "AUTO_CHARGE";
    CollectionMethod["OFFLINE"] = "OFFLINE";
    CollectionMethod["SEND_INVOICE"] = "SEND_INVOICE";
})(CollectionMethod = exports.CollectionMethod || (exports.CollectionMethod = {}));
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["UNKNOWN"] = "UNKNOWN";
    DurationUnit["DAY"] = "DAY";
    DurationUnit["WEEK"] = "WEEK";
    DurationUnit["MONTH"] = "MONTH";
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit = exports.DurationUnit || (exports.DurationUnit = {}));
var ExtendPolicyType;
(function (ExtendPolicyType) {
    ExtendPolicyType["PERIOD"] = "PERIOD";
    ExtendPolicyType["BILLING_CYCLE"] = "BILLING_CYCLE";
})(ExtendPolicyType = exports.ExtendPolicyType || (exports.ExtendPolicyType = {}));
var HistoryActionInitiator;
(function (HistoryActionInitiator) {
    HistoryActionInitiator["UNDEFINED"] = "UNDEFINED";
    HistoryActionInitiator["BUSINESS"] = "BUSINESS";
    HistoryActionInitiator["CUSTOMER"] = "CUSTOMER";
    HistoryActionInitiator["SYSTEM"] = "SYSTEM";
    HistoryActionInitiator["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
})(HistoryActionInitiator = exports.HistoryActionInitiator || (exports.HistoryActionInitiator = {}));
var IdentityType;
(function (IdentityType) {
    IdentityType["UNDEFINED"] = "UNDEFINED";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["CONTACT"] = "CONTACT";
})(IdentityType = exports.IdentityType || (exports.IdentityType = {}));
var ItemCategory;
(function (ItemCategory) {
    ItemCategory["UNKNOWN"] = "UNKNOWN";
    ItemCategory["PHYSICAL"] = "PHYSICAL";
    ItemCategory["DIGITAL"] = "DIGITAL";
})(ItemCategory = exports.ItemCategory || (exports.ItemCategory = {}));
var PauseAt;
(function (PauseAt) {
    PauseAt["NONE"] = "NONE";
    PauseAt["IMMEDIATELY"] = "IMMEDIATELY";
    PauseAt["NEXT_BILLING_DATE"] = "NEXT_BILLING_DATE";
    PauseAt["SPECIFIC_DATE"] = "SPECIFIC_DATE";
    PauseAt["NUMBER_OF_CYCLES_FROM_TODAY"] = "NUMBER_OF_CYCLES_FROM_TODAY";
})(PauseAt = exports.PauseAt || (exports.PauseAt = {}));
var PausePolicy;
(function (PausePolicy) {
    PausePolicy["NONE"] = "NONE";
    PausePolicy["SERVICE_AND_PAYMENTS"] = "SERVICE_AND_PAYMENTS";
    PausePolicy["SERVICE_ONLY"] = "SERVICE_ONLY";
})(PausePolicy = exports.PausePolicy || (exports.PausePolicy = {}));
var ResumeAt;
(function (ResumeAt) {
    ResumeAt["NONE"] = "NONE";
    ResumeAt["IMMEDIATELY"] = "IMMEDIATELY";
    ResumeAt["NEXT_BILLING_DATE"] = "NEXT_BILLING_DATE";
    ResumeAt["SPECIFIC_DATE"] = "SPECIFIC_DATE";
})(ResumeAt = exports.ResumeAt || (exports.ResumeAt = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Status;
(function (Status) {
    Status["UNDEFINED"] = "UNDEFINED";
    Status["ACTIVE"] = "ACTIVE";
    Status["ENDED"] = "ENDED";
})(Status = exports.Status || (exports.Status = {}));
var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency = exports.SubscriptionFrequency || (exports.SubscriptionFrequency = {}));
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["UNDEFINED"] = "UNDEFINED";
    SubscriptionType["ONLINE"] = "ONLINE";
    SubscriptionType["OFFLINE"] = "OFFLINE";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
var WixpressSubscriptionsApiV1ActionTypeEnumActionType;
(function (WixpressSubscriptionsApiV1ActionTypeEnumActionType) {
    WixpressSubscriptionsApiV1ActionTypeEnumActionType["NONE"] = "NONE";
    WixpressSubscriptionsApiV1ActionTypeEnumActionType["SUSPEND"] = "SUSPEND";
    WixpressSubscriptionsApiV1ActionTypeEnumActionType["RESUME"] = "RESUME";
    WixpressSubscriptionsApiV1ActionTypeEnumActionType["MARK_AS_PAID"] = "MARK_AS_PAID";
    WixpressSubscriptionsApiV1ActionTypeEnumActionType["CANCEL_NOW"] = "CANCEL_NOW";
    WixpressSubscriptionsApiV1ActionTypeEnumActionType["CANCEL_NEXT_PAYMENT_DATE"] = "CANCEL_NEXT_PAYMENT_DATE";
    WixpressSubscriptionsApiV1ActionTypeEnumActionType["UPDATE_VALID_UNTIL"] = "UPDATE_VALID_UNTIL";
    WixpressSubscriptionsApiV1ActionTypeEnumActionType["UPDATE_FROM"] = "UPDATE_FROM";
    WixpressSubscriptionsApiV1ActionTypeEnumActionType["UPDATE_FROM_AND_VALID_UNTIL"] = "UPDATE_FROM_AND_VALID_UNTIL";
})(WixpressSubscriptionsApiV1ActionTypeEnumActionType = exports.WixpressSubscriptionsApiV1ActionTypeEnumActionType || (exports.WixpressSubscriptionsApiV1ActionTypeEnumActionType = {}));
var WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus;
(function (WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus) {
    WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus["UNDEFINED"] = "UNDEFINED";
    WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus["PAID"] = "PAID";
    WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus["REFUNDED"] = "REFUNDED";
    WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus["FAILED"] = "FAILED";
    WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus["UNPAID"] = "UNPAID";
    WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus["PENDING"] = "PENDING";
})(WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus = exports.WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus || (exports.WixpressSubscriptionsApiV1PaymentStatusEnumPaymentStatus = {}));
var WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus;
(function (WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus) {
    WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["UNDEFINED"] = "UNDEFINED";
    WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["DRAFT"] = "DRAFT";
    WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["PENDING"] = "PENDING";
    WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["ACTIVE"] = "ACTIVE";
    WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["EXPIRED"] = "EXPIRED";
    WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["CANCELED"] = "CANCELED";
    WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["PENDING_CANCELLATION"] = "PENDING_CANCELLATION";
    WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus["SUSPENDED"] = "SUSPENDED";
})(WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus = exports.WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus || (exports.WixpressSubscriptionsApiV1SubscriptionStatusEnumSubscriptionStatus = {}));
//# sourceMappingURL=types.js.map